import React, { useState, useEffect, useRef } from 'react';

const ServicesSection1 = ({ name }) => {
  const logo = `${process.env.PUBLIC_URL}/assets/Logo.webp`;

  const [loaded, setLoaded] = useState(false);
  const videoRef = useRef(null);

  // Overlay only for Training so the Services video banner stays unchanged elsewhere.
  const customTitle =
    name && String(name).trim().toLowerCase() === 'training'
      ? 'TRAINING'
      : null;

  useEffect(() => {
    const handleLoadedData = () => {
      setLoaded(true);
    };

    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.addEventListener('loadeddata', handleLoadedData);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener('loadeddata', handleLoadedData);
      }
    };
  }, []);

  return (
    <div className="w-full relative">
      {!loaded && (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-20">
          <img src={logo} alt="Mba Solutions" className="animate-ping lg:w-auto lg:h-auto w-[140px] h-[90px]" />
        </div>
      )}
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        preload="auto"
        className={`${loaded ? 'loaded' : ''} bg-cover object-contain`}
        width="100%"
      >
        <source src="https://api.mbasolutions.co/api/video/services" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {customTitle && (
        <div className="pointer-events-none absolute inset-0 z-10" aria-label={customTitle}>
          {/* Covers the baked-in "SERVICES" word; position matched to Services.mp4 frame */}
          <div
            className="absolute flex items-center justify-start overflow-hidden"
            style={{
              left: '34.2%',
              top: '39.2%',
              width: '23.5%',
              height: '13%',
              backgroundColor: '#d3d3d3',
            }}
          >
            <span
              className="font-extrabold uppercase leading-none tracking-wide text-[#1a1040] whitespace-nowrap"
              style={{
                fontSize: 'clamp(1.1rem, 4.6vw, 3.75rem)',
                lineHeight: 1,
              }}
            >
              {customTitle}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServicesSection1;
